import { PropTypes } from 'prop-types'
import { Tooltip } from '../../../../../common/tooltip'
import { CustomRenderToolTip } from '../../components/bottomComponent/components/premiumUser/creditRiskScore/topContent/RangeScoreLevel'

const StackColorBarYAxis = (props) => {
  const {
    yAxisMap,
    yAxisId,
    ranges: { breakValues, data },
    barWidth = 16,
  } = props

  const renderBar = () => {
    const yAxis = yAxisMap[yAxisId]
    if (!yAxis) return null

    const { x, y, scale, width, height } = yAxis

    const breakCoordinateY = [
      y,
      ...breakValues.map(scale).reverse(),
      y + height,
    ]

    const renderTooltipDiscount = (item) => {
      return <CustomRenderToolTip item={item} />
    }

    return data.map((item, index) => (
      <g key={item.scoreRangeId}>
        <foreignObject
          x={x + width - barWidth}
          y={breakCoordinateY[index]}
          width={barWidth}
          height={breakCoordinateY[index + 1] - breakCoordinateY[index]}
        >
          <div
            style={{
              backgroundColor: item.color,
              height: '100%',
              width: '100%',
            }}
          >
            <Tooltip
              tooltipContent={renderTooltipDiscount(item)}
              tooltipSpace={-10}
              contentStyle={{ height: '100%', width: '100%' }}
              isHiddenInsideContent
            >
              <></>
            </Tooltip>
          </div>
        </foreignObject>
      </g>
    ))
  }

  return renderBar()
}

StackColorBarYAxis.propTypes = {
  yAxisId: PropTypes.string.isRequired,
  ranges: PropTypes.shape({
    breakValues: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
  }).isRequired,
  barWidth: PropTypes.number,
  // All rechart customized component props
}

export default StackColorBarYAxis
